import React from "react";
import PropTypes from "prop-types";

import { Mutation } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import { contractIdFromPath } from "../../lib/Util/url";

class ContractCheckbox extends React.Component {
  state = {
    checked: this.props.row.data.onContract
  };
  render() {
    const rowData = this.props.row.data;
    return (
      <Mutation
        mutation={TOGGLE_CONTRACT}
        onError={this.onError}
        onCompleted={this.onCompleted}
      >
        {update => (
          <React.Fragment>
            <input
              type="checkbox"
              id={`contract-np-user-${rowData.id}`}
              checked={this.state.checked}
              onChange={() => this.send(update, rowData.id)}
              style={{ marginRight: 5 }}
            />
            <label
              htmlFor={`contract-np-user-${rowData.id}`}
              style={{ cursor: "pointer" }}
            >
              On Contract
            </label>
          </React.Fragment>
        )}
      </Mutation>
    );
  }

  send = (update, userId) => {
    update({
      variables: {
        id: userId,
        contractId: contractIdFromPath()
      }
    });
  };

  onError = ({ graphQLErrors, networkError }) => {
    console.log("onError occurred");
    console.log(graphQLErrors);
    console.log(networkError);
  };

  onCompleted = data => {
    this.setState({ checked: data.toggleUserContract.onContract });
    const newRowData = {
      ...this.props.row.data,
      onContract: data.toggleUserContract.onContract
    };
    this.props.row.node.setData(newRowData);
  };
}

ContractCheckbox.propTypes = {
  row: PropTypes.object.isRequired
};

export default ContractCheckbox;

const TOGGLE_CONTRACT = gql`
  mutation toggleUserContract($id: ID!, $contractId: ID!) {
    toggleUserContract(id: $id, contractId: $contractId) {
      onContract
    }
  }
`;
